export default __webpack_public_path__ + "static/media/prod.9a5d6c7a.png";